import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Search, X } from "lucide-react";

export interface SearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    onClear: () => void;
    placeholder?: string;
    className?: string;
}

export function SearchField({
    value,
    onChange,
    onClear,
    placeholder = "Search...",
    className = "relative w-64",
}: SearchFieldProps) {
    return (
        <div className={className}>
            <Search className="text-muted-foreground pointer-events-none absolute top-1/2 left-2.5 size-3.5 -translate-y-1/2" />
            <Input
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={cn(
                    "h-8 pl-8 text-sm",
                    // Only reserve space for the clear button once it's
                    // actually showing; otherwise let the placeholder use
                    // the full width.
                    value ? "pr-8" : "pr-2"
                )}
            />
            {value && (
                <button
                    type="button"
                    aria-label="Clear search"
                    onClick={onClear}
                    className="text-muted-foreground hover:text-foreground absolute top-1/2 right-2 -translate-y-1/2 transition-colors"
                >
                    <X className="size-3.5" />
                </button>
            )}
        </div>
    );
}
